var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    transform: "translate(2.25 2.250002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.25 1.499998h2.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 1.499998h8.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.25 6.749998h8.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 6.749998h2.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.25 11.999998h2.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 11.999998h8.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.81065.43934006c.5857867.58578675.5857867 1.535535 0 2.1213225-.5857868.58578675-1.535535.58578675-2.1213225 0-.58578675-.58578675-.58578675-1.535535 0-2.1213225.58578675-.58578675 1.535535-.58578675 2.1213225 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.8106575 5.68934756c.58578675.58578675.58578675 1.535535 0 2.1213225-.58578675.58578675-1.535535.58578675-2.1213225 0-.58578675-.58578675-.58578675-1.535535 0-2.1213225.58578675-.58578675 1.535535-.58578675 2.1213225 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.81065 10.9393476c.5857867.5857867.5857867 1.535535 0 2.1213225-.5857868.5857867-1.535535.5857867-2.1213225 0-.58578675-.5857868-.58578675-1.535535 0-2.1213225.58578675-.5857868 1.535535-.5857868 2.1213225 0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h18v18h-18z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.4577815002376acd22a6caa451e45ed9.svg";
export { ForwardRef as ReactComponent };